/**
 * Arabic translation lookups for dropdown lists.
 * Keys are the English values stored in the database.
 */

export const NATIONALITY_AR: Record<string, string> = {
  'Afghan': 'أفغاني',
  'Albanian': 'ألباني',
  'Algerian': 'جزائري',
  'American': 'أمريكي',
  'Argentinian': 'أرجنتيني',
  'Australian': 'أسترالي',
  'Bahraini': 'بحريني',
  'Bangladeshi': 'بنغلاديشي',
  'Belgian': 'بلجيكي',
  'Brazilian': 'برازيلي',
  'British': 'بريطاني',
  'Bulgarian': 'بلغاري',
  'Canadian': 'كندي',
  'Chinese': 'صيني',
  'Colombian': 'كولومبي',
  'Croatian': 'كرواتي',
  'Czech': 'تشيكي',
  'Danish': 'دنماركي',
  'Dutch': 'هولندي',
  'Egyptian': 'مصري',
  'Emirati': 'إماراتي',
  'Ethiopian': 'إثيوبي',
  'Filipino': 'فلبيني',
  'Finnish': 'فنلندي',
  'French': 'فرنسي',
  'German': 'ألماني',
  'Greek': 'يوناني',
  'Hungarian': 'مجري',
  'Indian': 'هندي',
  'Indonesian': 'إندونيسي',
  'Iranian': 'إيراني',
  'Iraqi': 'عراقي',
  'Irish': 'أيرلندي',
  'Italian': 'إيطالي',
  'Japanese': 'ياباني',
  'Jordanian': 'أردني',
  'Kazakh': 'كازاخستاني',
  'Kenyan': 'كيني',
  'Korean': 'كوري',
  'Kuwaiti': 'كويتي',
  'Lebanese': 'لبناني',
  'Libyan': 'ليبي',
  'Malaysian': 'ماليزي',
  'Mexican': 'مكسيكي',
  'Moroccan': 'مغربي',
  'Nepali': 'نيبالي',
  'New Zealander': 'نيوزيلندي',
  'Nigerian': 'نيجيري',
  'Norwegian': 'نرويجي',
  'Omani': 'عماني',
  'Pakistani': 'باكستاني',
  'Palestinian': 'فلسطيني',
  'Peruvian': 'بيروفي',
  'Polish': 'بولندي',
  'Portuguese': 'برتغالي',
  'Qatari': 'قطري',
  'Romanian': 'روماني',
  'Russian': 'روسي',
  'Saudi': 'سعودي',
  'Senegalese': 'سنغالي',
  'Serbian': 'صربي',
  'Singaporean': 'سنغافوري',
  'Slovak': 'سلوفاكي',
  'South African': 'جنوب أفريقي',
  'Spanish': 'إسباني',
  'Sri Lankan': 'سريلانكي',
  'Sudanese': 'سوداني',
  'Swedish': 'سويدي',
  'Swiss': 'سويسري',
  'Syrian': 'سوري',
  'Taiwanese': 'تايواني',
  'Thai': 'تايلاندي',
  'Tunisian': 'تونسي',
  'Turkish': 'تركي',
  'Ukrainian': 'أوكراني',
  'Venezuelan': 'فنزويلي',
  'Vietnamese': 'فيتنامي',
  'Yemeni': 'يمني',
};

export const COUNTRY_AR: Record<string, string> = {
  'Saudi Arabia': 'المملكة العربية السعودية',
  'United Arab Emirates': 'الإمارات العربية المتحدة',
  'Qatar': 'قطر',
  'Oman': 'عُمان',
  'Kuwait': 'الكويت',
  'Bahrain': 'البحرين',
  'Egypt': 'مصر',
  'Jordan': 'الأردن',
  'Lebanon': 'لبنان',
  'Iraq': 'العراق',
  'Syria': 'سوريا',
  'Palestine': 'فلسطين',
  'Yemen': 'اليمن',
  'Libya': 'ليبيا',
  'Tunisia': 'تونس',
  'Algeria': 'الجزائر',
  'Morocco': 'المغرب',
  'Sudan': 'السودان',
  'Somalia': 'الصومال',
  'Mauritania': 'موريتانيا',
  'Djibouti': 'جيبوتي',
  'Comoros': 'جزر القمر',
  'India': 'الهند',
  'Pakistan': 'باكستان',
  'Bangladesh': 'بنغلاديش',
  'Sri Lanka': 'سريلانكا',
  'Nepal': 'نيبال',
  'Philippines': 'الفلبين',
  'Indonesia': 'إندونيسيا',
  'Malaysia': 'ماليزيا',
  'Thailand': 'تايلاند',
  'Vietnam': 'فيتنام',
  'South Korea': 'كوريا الجنوبية',
  'Japan': 'اليابان',
  'China': 'الصين',
  'Taiwan': 'تايوان',
  'Singapore': 'سنغافورة',
  'Turkey': 'تركيا',
  'Iran': 'إيران',
  'Afghanistan': 'أفغانستان',
  'Kazakhstan': 'كازاخستان',
  'Uzbekistan': 'أوزبكستان',
  'United Kingdom': 'المملكة المتحدة',
  'Germany': 'ألمانيا',
  'France': 'فرنسا',
  'Spain': 'إسبانيا',
  'Italy': 'إيطاليا',
  'Netherlands': 'هولندا',
  'Belgium': 'بلجيكا',
  'Switzerland': 'سويسرا',
  'Austria': 'النمسا',
  'Sweden': 'السويد',
  'Norway': 'النرويج',
  'Denmark': 'الدنمارك',
  'Finland': 'فنلندا',
  'Ireland': 'أيرلندا',
  'Poland': 'بولندا',
  'Romania': 'رومانيا',
  'Czech Republic': 'التشيك',
  'Hungary': 'المجر',
  'Greece': 'اليونان',
  'Portugal': 'البرتغال',
  'Russia': 'روسيا',
  'Ukraine': 'أوكرانيا',
  'United States': 'الولايات المتحدة',
  'Canada': 'كندا',
  'Mexico': 'المكسيك',
  'Brazil': 'البرازيل',
  'Argentina': 'الأرجنتين',
  'Colombia': 'كولومبيا',
  'Australia': 'أستراليا',
  'New Zealand': 'نيوزيلندا',
  'South Africa': 'جنوب أفريقيا',
  'Nigeria': 'نيجيريا',
  'Kenya': 'كينيا',
  'Ethiopia': 'إثيوبيا',
  'Ghana': 'غانا',
  'Senegal': 'السنغال',
};

export const CITY_AR: Record<string, string> = {
  // Saudi Arabia
  'Riyadh': 'الرياض',
  'Jeddah': 'جدة',
  'Makkah': 'مكة المكرمة',
  'Madinah': 'المدينة المنورة',
  'Dammam': 'الدمام',
  'Khobar': 'الخبر',
  'Dhahran': 'الظهران',
  'Taif': 'الطائف',
  'Tabuk': 'تبوك',
  'Buraidah': 'بريدة',
  'Khamis Mushait': 'خميس مشيط',
  'Abha': 'أبها',
  'Hail': 'حائل',
  'Najran': 'نجران',
  'Jazan': 'جازان',
  'Yanbu': 'ينبع',
  'Al Ahsa': 'الأحساء',
  'Jubail': 'الجبيل',
  'Al Qatif': 'القطيف',
  'Arar': 'عرعر',
  'Sakaka': 'سكاكا',
  'Al Baha': 'الباحة',
  'Bisha': 'بيشة',
  'Unaizah': 'عنيزة',
  'Al Kharj': 'الخرج',
  'Hafar Al-Batin': 'حفر الباطن',
  'Al Majmaah': 'المجمعة',
  'Dawadmi': 'الدوادمي',
  'Afif': 'عفيف',
  'Wadi Al-Dawasir': 'وادي الدواسر',
  'Sharurah': 'شرورة',
  'Turaif': 'طريف',
  'Rafha': 'رفحاء',
  'Al Lith': 'الليث',
  'Rabigh': 'رابغ',
  'Al Qunfudhah': 'القنفذة',
  'Muhayil': 'محايل',
  'Al Namas': 'النماص',
  'Tabarjal': 'طبرجل',
  'Dumat Al-Jandal': 'دومة الجندل',
  'Al Ula': 'العلا',
  'Khaybar': 'خيبر',
  'Badr': 'بدر',
  'Al Hanakiyah': 'الحناكية',
  'Mahd Al-Dhahab': 'مهد الذهب',
  'Al Zulfi': 'الزلفي',
  'Shaqra': 'شقراء',
  'Hotat Bani Tamim': 'حوطة بني تميم',
  'Al Aflaj': 'الأفلاج',
  'Layla': 'ليلى',
  'Al Dilam': 'الدلم',
  'Samtah': 'صامطة',
  'Abu Arish': 'أبو عريش',
  'Sabya': 'صبيا',
  'Al Darb': 'الدرب',
  'Farasan': 'فرسان',
  // UAE
  'Dubai': 'دبي',
  'Abu Dhabi': 'أبوظبي',
  'Sharjah': 'الشارقة',
  'Ajman': 'عجمان',
  'Ras Al Khaimah': 'رأس الخيمة',
  'Fujairah': 'الفجيرة',
  'Umm Al Quwain': 'أم القيوين',
  'Al Ain': 'العين',
  'Khor Fakkan': 'خورفكان',
  'Kalba': 'كلباء',
  'Dibba Al-Hisn': 'دبا الحصن',
  'Dibba Al-Fujairah': 'دبا الفجيرة',
  'Jebel Ali': 'جبل علي',
  'Ghayathi': 'غياثي',
  'Liwa': 'ليوا',
  'Madinat Zayed': 'مدينة زايد',
  'Ruwais': 'الرويس',
  'Dhaid': 'الذيد',
  'Masafi': 'مسافي',
  'Hatta': 'حتا',
  // Qatar
  'Doha': 'الدوحة',
  'Al Wakrah': 'الوكرة',
  'Al Khor': 'الخور',
  'Lusail': 'لوسيل',
  'Al Rayyan': 'الريان',
  'Umm Salal': 'أم صلال',
  'Al Daayen': 'الضعاين',
  'Al Shamal': 'الشمال',
  'Al Shahaniya': 'الشحانية',
  'Mesaieed': 'مسيعيد',
  'Dukhan': 'دخان',
  // Oman
  'Muscat': 'مسقط',
  'Salalah': 'صلالة',
  'Sohar': 'صحار',
  'Nizwa': 'نزوى',
  'Sur': 'صور',
  'Ibri': 'عبري',
  'Barka': 'بركاء',
  'Rustaq': 'الرستاق',
  'Seeb': 'السيب',
  'Mutrah': 'مطرح',
  'Bahla': 'بهلاء',
  'Al Buraimi': 'البريمي',
  'Khasab': 'خصب',
  'Saham': 'صحم',
  'Shinas': 'شناص',
  'Al Suwayq': 'السويق',
  'Duqm': 'الدقم',
  'Haima': 'هيماء',
  'Adam': 'أدم',
  'Bidbid': 'بدبد',
  'Bidiyah': 'بدية',
  // Kuwait
  'Kuwait City': 'مدينة الكويت',
  'Hawalli': 'حولي',
  'Salmiya': 'السالمية',
  'Farwaniya': 'الفروانية',
  'Jahra': 'الجهراء',
  'Ahmadi': 'الأحمدي',
  'Mangaf': 'المنقف',
  'Fahaheel': 'الفحيحيل',
  'Sabah Al Salem': 'صباح السالم',
  'Mishref': 'مشرف',
  'Rumaithiya': 'الرميثية',
  'Fintas': 'الفنطاس',
  'Mahboula': 'المهبولة',
  'Abu Halifa': 'أبو حليفة',
  'Jleeb Al-Shuyoukh': 'جليب الشيوخ',
  // Bahrain
  'Manama': 'المنامة',
  'Riffa': 'الرفاع',
  'Muharraq': 'المحرق',
  'Isa Town': 'مدينة عيسى',
  'Sitra': 'سترة',
  'Hamad Town': 'مدينة حمد',
  'Budaiya': 'البديع',
  'Jidhafs': 'جدحفص',
  'Al Hidd': 'الحد',
  'Zallaq': 'الزلاق',
  'Amwaj Islands': 'جزر أمواج',
  'Tubli': 'توبلي',
  // Egypt
  'Cairo': 'القاهرة',
  'Alexandria': 'الإسكندرية',
  'Giza': 'الجيزة',
  'Sharm El Sheikh': 'شرم الشيخ',
  'Hurghada': 'الغردقة',
  'Luxor': 'الأقصر',
  'Aswan': 'أسوان',
  'Port Said': 'بورسعيد',
  'Suez': 'السويس',
  'Mansoura': 'المنصورة',
  'Tanta': 'طنطا',
  'Ismailia': 'الإسماعيلية',
  'Fayyum': 'الفيوم',
  'Zagazig': 'الزقازيق',
  'Damietta': 'دمياط',
  'Minya': 'المنيا',
  'Beni Suef': 'بني سويف',
  'Sohag': 'سوهاج',
  'Qena': 'قنا',
  'Assiut': 'أسيوط',
  'Kafr El Sheikh': 'كفر الشيخ',
  // Jordan
  'Amman': 'عمّان',
  'Aqaba': 'العقبة',
  'Irbid': 'إربد',
  'Zarqa': 'الزرقاء',
  'Madaba': 'مادبا',
  'Jerash': 'جرش',
  'Ajloun': 'عجلون',
  'Salt': 'السلط',
  'Karak': 'الكرك',
  'Tafilah': 'الطفيلة',
  'Mafraq': 'المفرق',
  'Maan': 'معان',
  'Russeifa': 'الرصيفة',
  'Sahab': 'سحاب',
  // Lebanon
  'Beirut': 'بيروت',
  'Tripoli': 'طرابلس',
  'Sidon': 'صيدا',
  'Jounieh': 'جونية',
  'Byblos': 'جبيل',
  'Baalbek': 'بعلبك',
  'Zahle': 'زحلة',
};

export const EDUCATION_LEVEL_AR: Record<string, string> = {
  'High School': 'ثانوية عامة',
  'Diploma': 'دبلوم',
  "Associate's Degree": 'درجة مشارك',
  "Bachelor's Degree": 'بكالوريوس',
  "Master's Degree": 'ماجستير',
  'MBA': 'ماجستير إدارة أعمال',
  'Doctorate / PhD': 'دكتوراه',
  'Professional Certification': 'شهادة مهنية',
};

export const INDUSTRY_AR: Record<string, string> = {
  'Accounting & Auditing': 'المحاسبة والمراجعة',
  'Advertising & Marketing': 'الإعلان والتسويق',
  'Aerospace & Defense': 'الفضاء والدفاع',
  'Agriculture & Farming': 'الزراعة',
  'Architecture & Planning': 'العمارة والتخطيط',
  'Automotive': 'السيارات',
  'Aviation & Airlines': 'الطيران',
  'Banking & Financial Services': 'البنوك والخدمات المالية',
  'Biotechnology': 'التقنية الحيوية',
  'Broadcasting & Media': 'الإعلام',
  'Business Consulting': 'الاستشارات',
  'Chemicals': 'الكيماويات',
  'Civil Engineering': 'الهندسة المدنية',
  'Cloud Computing': 'الحوسبة السحابية',
  'Construction': 'البناء والتشييد',
  'Consumer Electronics': 'الإلكترونيات الاستهلاكية',
  'Consumer Goods & FMCG': 'السلع الاستهلاكية',
  'Cybersecurity': 'الأمن السيبراني',
  'Data Analytics & AI': 'تحليل البيانات والذكاء الاصطناعي',
  'Design & Creative Services': 'التصميم والخدمات الإبداعية',
  'E-Commerce': 'التجارة الإلكترونية',
  'Education & Training': 'التعليم والتدريب',
  'Electrical & Electronics': 'الكهرباء والإلكترونيات',
  'Energy & Utilities': 'الطاقة والمرافق',
  'Entertainment & Gaming': 'الترفيه والألعاب',
  'Environmental Services': 'الخدمات البيئية',
  'Events & Conferences': 'الفعاليات والمؤتمرات',
  'Fashion & Apparel': 'الأزياء والملابس',
  'Film & Animation': 'الأفلام والرسوم المتحركة',
  'Financial Technology (FinTech)': 'التقنية المالية',
  'Food & Beverage': 'الأغذية والمشروبات',
  'Furniture & Interiors': 'الأثاث والديكور',
  'Government & Public Sector': 'القطاع الحكومي',
  'Healthcare & Medical': 'الرعاية الصحية',
  'Hospitality & Hotels': 'الضيافة والفنادق',
  'Human Resources & Recruitment': 'الموارد البشرية والتوظيف',
  'Import & Export': 'الاستيراد والتصدير',
  'Industrial Manufacturing': 'التصنيع',
  'Information Technology (IT)': 'تقنية المعلومات',
  'Insurance': 'التأمين',
  'Interior Design': 'التصميم الداخلي',
  'International Development': 'التنمية الدولية',
  'Investment & Private Equity': 'الاستثمار ورأس المال',
  'Islamic Finance': 'التمويل الإسلامي',
  'Jewelry & Luxury Goods': 'المجوهرات والسلع الفاخرة',
  'Legal Services': 'الخدمات القانونية',
  'Logistics & Supply Chain': 'اللوجستيات وسلسلة الإمداد',
  'Management Consulting': 'الاستشارات الإدارية',
  'Maritime & Shipping': 'الشحن البحري',
  'Mechanical Engineering': 'الهندسة الميكانيكية',
  'Medical Devices': 'الأجهزة الطبية',
  'Mining & Metals': 'التعدين والمعادن',
  'Music & Audio': 'الموسيقى والصوتيات',
  'NGO & Nonprofit': 'المنظمات غير الربحية',
  'Oil & Gas': 'النفط والغاز',
  'Petrochemicals': 'البتروكيماويات',
  'Pharmaceuticals': 'الأدوية',
  'Photography': 'التصوير',
  'Printing & Publishing': 'الطباعة والنشر',
  'Professional Services': 'الخدمات المهنية',
  'Property Management': 'إدارة العقارات',
  'Public Relations': 'العلاقات العامة',
  'Quality Assurance & Testing': 'ضمان الجودة والاختبار',
  'Real Estate & Development': 'العقارات والتطوير',
  'Renewable Energy': 'الطاقة المتجددة',
  'Research & Development': 'البحث والتطوير',
  'Restaurants & Catering': 'المطاعم والتموين',
  'Retail': 'التجزئة',
  'Robotics & Automation': 'الروبوتات والأتمتة',
  'SaaS & Software': 'البرمجيات',
  'Safety & Security Services': 'خدمات الأمن والسلامة',
  'Semiconductors': 'أشباه الموصلات',
  'Social Media': 'وسائل التواصل الاجتماعي',
  'Sports & Fitness': 'الرياضة واللياقة',
  'Staffing & Outsourcing': 'التوظيف والتعهيد',
  'Telecommunications': 'الاتصالات',
  'Textiles & Garments': 'المنسوجات والملابس',
  'Tourism & Travel': 'السياحة والسفر',
  'Trading & Distribution': 'التجارة والتوزيع',
  'Transportation': 'النقل',
  'Urban Planning': 'التخطيط العمراني',
  'Venture Capital': 'رأس المال المخاطر',
  'Veterinary Services': 'الخدمات البيطرية',
  'Warehousing & Storage': 'التخزين',
  'Water & Waste Management': 'المياه وإدارة النفايات',
  'Wholesale': 'تجارة الجملة',
};
